import React from 'react';
import { images } from '../data/content';
import { SectionCTA } from './SectionCTA';
export function Creator() {
  return <section className="bg-cream-deep px-4 py-16" aria-labelledby="c-title" data-id="element-94" data-mp="26cctmq5r1tbl">
      <div className="mx-auto grid max-w-5xl items-center gap-8 md:grid-cols-[0.9fr_1.1fr] md:gap-12" data-id="element-95" data-mp="228okw45dsror">
        <img src={images.creator} alt="Ethan Whitmore in the operating room" className="mx-auto w-full max-w-sm rounded-3xl border-4 border-white object-cover shadow-[0_24px_50px_-24px_rgba(11,11,12,0.5)]" loading="lazy" data-id="element-96" data-mp="1x9bnwqksq48g" />
        <div data-id="element-97" data-mp="1il7ekd7mv52c">
          <p className="text-sm font-bold uppercase tracking-widest text-gold-dark" data-id="element-98" data-mp="1ikyykcg7rjmx">About the creator</p>
          <h2 id="c-title" className="mt-2 font-serif text-[2.2rem] font-bold leading-tight text-ink sm:text-5xl" data-id="element-99" data-mp="1ekolygxx1uz3">
            Ethan Whitmore
          </h2>
          <div className="mt-5 space-y-4 text-base leading-relaxed text-muted sm:text-lg" data-id="element-100" data-mp="19mn2vw0hpvnm">
            <p data-id="element-101" data-mp="14nskgv6fq941">Ethan Whitmore created Sculptor’s Operating Blueprint™ around a simple observation:</p>
            <p className="border-l-4 border-gold pl-4 font-serif text-xl italic text-ink" data-id="element-102" data-mp="21yaa385fypa6">
              Professionals in highly technical fields don’t necessarily need more information. They often need a better
              way to organize the information they already have.
            </p>
            <p data-id="element-103" data-mp="1xwozjtgdqn35">
              Rhinoplasty education can involve anatomy, facial analysis, surgical planning, technique selection, patient
              objectives, documentation, and continuous case review. When those elements are scattered across courses,
              notes, articles, and reference materials, building a consistent planning workflow can become unnecessarily
              difficult.
            </p>
            <p data-id="element-104" data-mp="10b10t1wgbsog">
              Not as another 15-hour course. Not as another theoretical textbook. But as a structured professional
              reference system built around five fundamental stages:{' '}
              <strong className="text-ink" data-id="element-105" data-mp="l7zuh0tiv69e">Analyze. Define. Plan. Prepare. Review.</strong>
            </p>
          </div>
        </div>
      </div>
      <div className="mx-auto max-w-5xl" data-id="element-106" data-mp="h7peqwfxh1hc">
        <SectionCTA label="I want Ethan’s Blueprint" data-id="element-107" data-mp="h8s95ecglm20" />
      </div>
    </section>;
}